var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-advantages-item"},[_c('div',{staticClass:"content",style:({ backgroundImage: `url(${_vm.info.imgUrl})` })}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"content-box"},[_vm._v(_vm._s(_vm.info.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }